import React, { useState } from 'react';
import HelmetTitle from './components/HelmetTitle/HelmetTitle';
import LoginPage from './components/LoginPage/LoginPage';
import Sidebar from './components/Sidebar/Sidebar';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import UserDetailsPage from './pages/UserDetailsPage';
import ProductsPage from './pages/ProductsPage';
import PositionsPage from './pages/PositionsPage';
import './App.css';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => localStorage.getItem('isLoggedIn') === 'true'
  );
  const [route, setRoute] = useState('dashboard');
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleLogin = () => {
    localStorage.setItem('isLoggedIn', 'true');
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    setIsLoggedIn(false);
    setSelectedUserId(null);
  };

  const renderPage = () => {
    switch (route) {
      case 'users':
        return <UsersPage onUserClick={(id) => { setSelectedUserId(id); setRoute('userDetails'); }} />;
      case 'userDetails':
        return <UserDetailsPage userId={selectedUserId} onBack={() => setRoute('users')} />;
      case 'products':
        return <ProductsPage />;
      case 'positions':
        return <PositionsPage />;
      default:
        return <DashboardPage />;
    }
  };

  return (
    <div className="App">
      {isLoggedIn ? (
        <>
          <HelmetTitle title="Dashboard" />
          <div className="layout">
            <Sidebar current={route} onNavigate={setRoute} />
            <div className="content-area">
              <div className="dashboard-header">
                <h1>Trading Dashboard</h1>
                <button className="logout-button" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt" />
                  <span>Log Out</span>
                </button>
              </div>
              {renderPage()}
            </div>
          </div>
        </>
      ) : (
        <>
          <HelmetTitle title="Login" />
          <LoginPage onLogin={handleLogin} />
        </>
      )}
    </div>
  );
}

export default App;
